import { axiosPrivate } from "src/common/axiosProtected";
import { downloadFile } from "src/components/utils";

export const addDriver = async (values) => {
  const response = await axiosPrivate.post("/admin/user", values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response;
};

export const getAdmins = async ({ params }) => {
  const response = await axiosPrivate.get(`/admin/admins${params}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};
export const getSingleAdmin = async (id) => {
  const response = await axiosPrivate.get(`/admin/admins/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addAdmin = async (values) => {
  const response = await axiosPrivate.post(`/admin/admins`, values);

  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateAdmin = async (values) => {
  const response = await axiosPrivate.put(`/admin/admins`, values);
  if (response.data.code !== 200) {
    throw new Error(response.data.message || "Request Failed.");
  }
  return response.data;
};

export const getAdminTypes = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin-type${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getFuntionsAll = async () => {
  const response = await axiosPrivate.get(`/function`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addPrivilegs = async (values) => {
  const response = await axiosPrivate.post(`/admin-type`, values);

  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const editPrivilegs = async (values, id) => {
  const response = await axiosPrivate.put(`/admin-type/${id}`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateUser =
  ({ values, callback }) =>
  async (dispatch) => {
    try {
      const response = await axiosPrivate.put(`/admin/user/update`, values);
      if (response.data.code !== 200) {
        throw new Error(response.data.message || "Request Failed.");
      }

      // Dispatch an action if needed (e.g., to update the Redux state)
      dispatch({ type: "UPDATE_USER_SUCCESS", payload: response.data });

      // Call the callback if the update was successful
      if (callback) {
        callback(response.data);
      }
    } catch (error) {
      console.error("Error updating user:", error);

      // Dispatch an error action if needed
      dispatch({ type: "UPDATE_USER_FAILURE", error: error.message });

      // Optionally, call the callback with `null` or `false` to handle the failure
      if (callback) {
        callback(null);
      }
    }
  };

export const getCarTypes = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/car-type${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addCarTypes = async (values) => {
  const response = await axiosPrivate.post(`/admin/car-type`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateCarTypes = async (values) => {
  const response = await axiosPrivate.put(`/admin/car-type/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deleteCarTypes = async (values) => {
  const response = await axiosPrivate.put(`/admin/car-type/delete`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const activateCarTypes = async (values) => {
  const response = await axiosPrivate.put(`/admin/car-type/activate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deActivateCarTypes = async (values) => {
  const response = await axiosPrivate.put(`/admin/car-type/deactivate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getCars = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/car${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleCars = async (id) => {
  const response = await axiosPrivate.get(`/admin/car/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateCars = async (values) => {
  const response = await axiosPrivate.put(`/admin/car/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addCars = async (values) => {
  const response = await axiosPrivate.post("admin/car", values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response;
};

export const getDriverZones = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/zone${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleZone = async (id) => {
  const response = await axiosPrivate.get(`/admin/zone/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addZones = async (values) => {
  const response = await axiosPrivate.post("admin/zone", values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response;
};

export const updateZones = async (values) => {
  const response = await axiosPrivate.put(`/admin/zone/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getCharityHistory = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/charity-history${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getCharities = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/charity${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleCharity = async (id) => {
  const response = await axiosPrivate.get(`/admin/charity/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateCharity = async (values) => {
  const response = await axiosPrivate.put(`/admin/charity/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addCharity = async (values) => {
  const response = await axiosPrivate.post(`/admin/charity`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getMakeIds = async () => {
  const response = await axiosPrivate.get(`/admin/car/make?limit=1000`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getModelIds = async (id) => {
  const response = await axiosPrivate.get(`/admin/car/model/${id}?limit=1000`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getAdditonalCharges = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/additional${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};
export const getSingleAdditonalCharges = async (id) => {
  const response = await axiosPrivate.get(`/admin/additional/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addAdditonalCharges = async (values) => {
  const response = await axiosPrivate.post(`/admin/additional`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateAdditonalCharges = async (values) => {
  const response = await axiosPrivate.put(`/admin/additional/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getClientLoyalty = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/loyalty${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleClientLoyalty = async (id) => {
  const response = await axiosPrivate.get(`/admin/loyalty/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addClientLoyalty = async (values) => {
  const response = await axiosPrivate.post(`/admin/loyalty`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateClientLoyalty = async (values) => {
  const response = await axiosPrivate.put(`/admin/loyalty/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getPreferenceTypes = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/preference-type${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSinglePreferenceTypes = async (id) => {
  const response = await axiosPrivate.get(`/admin/preference-type/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addPreferenceTypes = async (values) => {
  const response = await axiosPrivate.post(`/admin/preference-type`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updatePreferenceTypes = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/preference-type/update`,
    values,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getPreferenceNames = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/preference-name${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSinglePreferenceNames = async (id) => {
  const response = await axiosPrivate.get(`/admin/preference-name/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addPreferenceNames = async (values) => {
  const response = await axiosPrivate.post(`/admin/preference-name`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updatePreferenceNames = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/preference-name/update`,
    values,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getDrivers = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/driver${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

/** Driver list with assigned subservices. §2.1 — not the by-id driver route. */
export const findDriverWithSubservices = async (driverId, term = "") => {
  const limit = 50;
  const loadPage = (page, searchTerm) => {
    const params = new URLSearchParams({
      withSubservices: "true",
      limit: String(limit),
      page: String(page),
    });
    if (searchTerm) params.set("term", searchTerm);
    return getDrivers({ params: `?${params.toString()}` });
  };

  if (term) {
    const searched = await loadPage(1, term);
    const match = (searched?.data || []).find((item) => item._id === driverId);
    if (match) return match;
  }

  let page = 1;
  while (page <= 10) {
    const results = await loadPage(page);
    const rows = results?.data || [];
    const match = rows.find((item) => item._id === driverId);
    if (match) return match;
    const total = Number(results?.totalCount || 0);
    if (!rows.length || page * limit >= total) return null;
    page += 1;
  }
  return null;
};

export const getSingleDriver = async (id) => {
  const response = await axiosPrivate.get(`/admin/driver/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const activateDriver = async (values) => {
  const response = await axiosPrivate.put(`/admin/driver/activate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deActivateDriver = async (values) => {
  const response = await axiosPrivate.put(`/admin/driver/deactivate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getUsers = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/user${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const activateUser = async (values) => {
  const response = await axiosPrivate.put(`/admin/user/activate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deActivateUser = async (values) => {
  const response = await axiosPrivate.put(`/admin/user/deactivate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleUser = async (id) => {
  const response = await axiosPrivate.get(`/admin/user/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addUser = async (values) => {
  const response = await axiosPrivate.post(`/admin/user`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateUsers = async (values) => {
  const response = await axiosPrivate.put(`/admin/user/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const activateAdminType = async (values) => {
  const response = await axiosPrivate.put(`/admin-type/activate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deActivateAdminType = async (values) => {
  const response = await axiosPrivate.put(`/admin-type/deactivate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getClientAddresses = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/admin/client-address${query}`);
  if (response.data.code !== 200) {
    throw new Error(response.data ?? "Request Failed.");
  }
  return response.data.results;
};

export const addClientAddress = async (values) => {
  const response = await axiosPrivate.post(`/admin/client-address`, values);
  if (response.status !== 201)
    throw new Error(response.data.message ?? "Request Failed.");
  return response.data.results;
};

export const updateClientAddress = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/client-address/update`,
    values,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleClientAddress = async (id) => {
  const response = await axiosPrivate.get(`/admin/client-address/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getServices = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/admin/service${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleService = async (id) => {
  const response = await axiosPrivate.get(`/admin/service/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addServices = async (values) => {
  const response = await axiosPrivate.post(`/admin/service`, values);
  if (response.data.code !== 201 && response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateServices = async (values) => {
  const response = await axiosPrivate.put(`/admin/service/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const activateServices = async (values) => {
  const response = await axiosPrivate.put(`/admin/service/activate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deactivateServices = async (values) => {
  const response = await axiosPrivate.put(`/admin/service/deactivate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSubservices = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/admin/subservice${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleSubservice = async (id) => {
  const response = await axiosPrivate.get(`/admin/subservice/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSubservicesByService = async (serviceId) => {
  const response = await axiosPrivate.get(
    `/admin/subservice/by-service/${serviceId}`,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

const unwrapAdminResults = (
  response,
  { allowCreated = false, fallback = "Request Failed." } = {},
) => {
  const data = response?.data;
  const ok = data?.code === 200 || (allowCreated && data?.code === 201);
  if (ok) return data.results;
  const err = new Error(
    typeof data?.message === "string" ? data.message : fallback,
  );
  err.response = { data, status: data?.code };
  err.apiPayload = data;
  throw err;
};

export const addSubservices = async (values) => {
  const response = await axiosPrivate.post(`/admin/subservice`, values);
  return unwrapAdminResults(response, { allowCreated: true });
};

export const updateSubservices = async (values) => {
  const response = await axiosPrivate.put(`/admin/subservice/update`, values);
  return unwrapAdminResults(response);
};

export const activateSubservices = async (values) => {
  const response = await axiosPrivate.put(`/admin/subservice/activate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deactivateSubservices = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/subservice/deactivate`,
    values,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addSubserviceInputField = async (subserviceId, field) => {
  const response = await axiosPrivate.post(
    `/admin/subservice/${subserviceId}/input-fields`,
    field,
    field instanceof FormData
      ? { headers: { "Content-Type": undefined } }
      : undefined,
  );
  return unwrapAdminResults(response, { allowCreated: true });
};

export const updateSubserviceInputField = async (
  subserviceId,
  fieldKey,
  field,
) => {
  const response = await axiosPrivate.put(
    `/admin/subservice/${subserviceId}/input-fields/${fieldKey}`,
    field,
    field instanceof FormData
      ? { headers: { "Content-Type": undefined } }
      : undefined,
  );
  return unwrapAdminResults(response);
};

export const deleteSubserviceInputField = async (
  subserviceId,
  fieldKey,
  { force = false } = {},
) => {
  const response = await axiosPrivate.delete(
    `/admin/subservice/${subserviceId}/input-fields/${fieldKey}${
      force ? "?force=true" : ""
    }`,
  );
  return unwrapAdminResults(response);
};

export const reorderSubserviceInputFields = async (subserviceId, pairs) => {
  const response = await axiosPrivate.put(
    `/admin/subservice/${subserviceId}/input-fields/reorder`,
    { pairs },
  );
  return unwrapAdminResults(response);
};

export const duplicateSubservice = async (id) => {
  const response = await axiosPrivate.post(`/admin/subservice/${id}/duplicate`);
  if (response.data.code !== 201 && response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSubserviceFieldStatistics = async (id) => {
  const response = await axiosPrivate.get(
    `/admin/subservice/${id}/field-statistics`,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const validateSubserviceDependencies = async (id) => {
  const response = await axiosPrivate.get(
    `/admin/subservice/${id}/validate-dependencies`,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getDriverSubserviceAssignments = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/admin/driver-subservice${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getDriverSubserviceAssignment = async (driverId) => {
  const response = await axiosPrivate.get(
    `/admin/driver-subservice/${driverId}`,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateDriverSubserviceAssignments = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/driver-subservice/update`,
    values,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const setServiceOrderQuote = async (values) => {
  const response = await axiosPrivate.put(`/admin/order/service-quote`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getOrders = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/order${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleOrder = async (id) => {
  const response = await axiosPrivate.get(`/admin/order/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addOrder = async (values, headers = {}) => {
  const response = await axiosPrivate.post(`/admin/order`, values, {
    headers: {
      ...headers,
    },
  });
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getUserLogs = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/user-log${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSettings = async () => {
  // Reads live on the shared setting router (no /admin prefix).
  // Writes still go through /admin/setting/update below.
  const response = await axiosPrivate.get(`/setting/admin`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateSettings = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/setting/update`,
    values,
    values instanceof FormData
      ? { headers: { "Content-Type": undefined } }
      : undefined,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getDriversOnline = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/driver${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getIssues = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/issue${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addIssue = async (values) => {
  const response = await axiosPrivate.post(`/admin/issue`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateIssue = async (values) => {
  const response = await axiosPrivate.put(`/admin/issue/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getReviews = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/review${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getContacts = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/contact${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getStatistics = async ({ params, id }) => {
  const response = await axiosPrivate.get(
    `/admin/driver/statistics/${id}${params}`,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getAllStatistics = async ({ params, id }) => {
  const response = await axiosPrivate.get(`/admin/statistics/${params}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateStatusOrder = async (values, headers = {}) => {
  const response = await axiosPrivate.put(`/admin/order/update`, values, {
    headers: {
      ...headers,
    },
  });
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getBalances = async (userId) => {
  const response = await axiosPrivate.get(`/admin/user/balance/${userId}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const paidOrders = async (values) => {
  const response = await axiosPrivate.put(`/admin/order/pay`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getCategories = async () => {
  const response = await axiosPrivate.get(`/admin/review-category`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addCategory = async (values) => {
  const response = await axiosPrivate.post(`/admin/review-category`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateCategory = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/review-category/update`,
    values,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleCategory = async (id) => {
  const response = await axiosPrivate.get(`/admin/review-category/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getTeam = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/admin/team${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleTeam = async (id) => {
  const response = await axiosPrivate.get(`/admin/team/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addTeam = async (values) => {
  const response = await axiosPrivate.post(`/admin/team`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateTeam = async (values) => {
  const response = await axiosPrivate.put(`/admin/team/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deleteTeam = async (values) => {
  const response = await axiosPrivate.put(`/admin/team/delete`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const activateTeam = async (values) => {
  const response = await axiosPrivate.put(`/admin/team/activate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deActivateTeam = async (values) => {
  const response = await axiosPrivate.put(`/admin/team/deactivate`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getTestimonial = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/admin/testimonial${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleTestimonial = async (id) => {
  const response = await axiosPrivate.get(`/admin/testimonial/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addTestimonial = async (values) => {
  const response = await axiosPrivate.post(`/admin/testimonial`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateTestimonial = async (values) => {
  const response = await axiosPrivate.put(`/admin/testimonial/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deleteTestimonial = async (values) => {
  const response = await axiosPrivate.put(`/admin/testimonial/delete`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const activateTestimonial = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/testimonial/activate`,
    values,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const deActivateTestimonial = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/testimonial/deactivate`,
    values,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getContactForm = async (params = {}) => {
  const query = params?.params ? `${params.params}` : "";
  const response = await axiosPrivate.get(`/admin/contact-form${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addEditWebsite = async (values) => {
  const response = await axiosPrivate.put(`/admin/website/update`, values);
  if (response.status !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data;
};

export const getWebsiteData = async () => {
  const response = await axiosPrivate.get(`/admin/website`);
  if (response.status !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const sendNotification = async (values) => {
  const response = await axiosPrivate.post(`/admin/broadcast`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getPriorityZones = async (id) => {
  const response = await axiosPrivate.get(`/admin/driver-zone?zone=${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updatePriorityZones = async (values) => {
  const response = await axiosPrivate.put(`/admin/driver-zone/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const exportTable = async (values) => {
  const response = await axiosPrivate.post(`/admin/export`, values);
  if (response.data.code === 201) {
    const filePath = response.data.results;
    const fileUrl = `${process.env.REACT_APP_ONLINE_URL}/${filePath}`;
    downloadFile(fileUrl);
  } else {
    throw new Error(response.data ?? "Request Failed.");
  }
};

export const getCarMake = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/car/make${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleCarMake = async (id) => {
  const response = await axiosPrivate.get(`/admin/car/make/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateCarMake = async (values) => {
  const response = await axiosPrivate.put(`/admin/car/make/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addCarMake = async (values) => {
  const response = await axiosPrivate.post("/admin/car/make", values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response;
};

export const deleteCarMake = async (id) => {
  const response = await axiosPrivate.delete(`/admin/car/make/delete/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getCarModel = async (data) => {
  const query = data?.params ? `${data.params}` : ""; // Check if params exist, otherwise default to an empty string
  const makeId = data.makeId;
  const response = await axiosPrivate.get(`/admin/car/model/${makeId}${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleCarModel = async (id) => {
  const response = await axiosPrivate.get(`/admin/car/model/get/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateCarModel = async (values) => {
  const response = await axiosPrivate.put(`/admin/car/model/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addCarModel = async (values) => {
  const response = await axiosPrivate.post("/admin/car/model", values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response;
};

export const deleteCarModel = async (id) => {
  const response = await axiosPrivate.delete(`/admin/car/model/delete/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getBlog = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/blog${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleBlog = async (id) => {
  const response = await axiosPrivate.get(`/admin/blog/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateBlog = async (values) => {
  const response = await axiosPrivate.put(`/admin/blog/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addBlog = async (values) => {
  const response = await axiosPrivate.post("/admin/blog", values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response;
};

export const deleteBlog = async (id) => {
  const response = await axiosPrivate.delete(`/admin/blog/delete/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getPromoCodes = async ({ params }) => {
  const response = await axiosPrivate.get(`/admin/promo-code${params}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};
export const getSinglePromoCode = async (id) => {
  const response = await axiosPrivate.get(`/admin/promo-code/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addPromoCode = async (values) => {
  const response = await axiosPrivate.post(`/admin/promo-code`, values);

  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updatePromoCode = async (values) => {
  const response = await axiosPrivate.put(`/admin/promo-code/update`, values);
  if (response.data.code !== 200) {
    throw new Error(response.data.message || "Request Failed.");
  }
  return response.data;
};

export const getPartners = async ({ params }) => {
  const response = await axiosPrivate.get(`/admin/partner${params}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};
export const getSinglePartner = async (id) => {
  const response = await axiosPrivate.get(`/admin/partner/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addPartner = async (values) => {
  const response = await axiosPrivate.post(`/admin/partner`, values);

  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updatePartner = async (values) => {
  const response = await axiosPrivate.put(`/admin/partner/update`, values);
  if (response.data.code !== 200) {
    throw new Error(response.data.message || "Request Failed.");
  }
  return response.data;
};

export const getRedeemLoyaltyPoints = async ({ params }) => {
  const response = await axiosPrivate.get(
    `/admin/redeem-loyalty-point${params}`,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getLoyaltyPoints = async ({ params }) => {
  const response = await axiosPrivate.get(`/admin/loyalty-point${params}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getLoyaltyPrograms = async ({ params }) => {
  const response = await axiosPrivate.get(`/admin/loyalty-program${params}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};
export const getSingleLoyaltyProgram = async (id) => {
  const response = await axiosPrivate.get(`/admin/loyalty-program/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addLoyaltyProgram = async (values) => {
  const response = await axiosPrivate.post(`/admin/loyalty-program`, values);

  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateLoyaltyProgram = async (values) => {
  const response = await axiosPrivate.put(
    `/admin/loyalty-program/update`,
    values,
  );
  if (response.data.code !== 200) {
    throw new Error(response.data.message || "Request Failed.");
  }
  return response.data;
};

export const getDriverVideo = async ({ params }) => {
  const response = await axiosPrivate.get(`/admin/driver-video${params}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};
export const getSingleDriverVideo = async (id) => {
  const response = await axiosPrivate.get(`/admin/driver-video/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addDriverVideo = async (values) => {
  const response = await axiosPrivate.post(`/admin/driver-video`, values);

  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateDriverVideo = async (values) => {
  const response = await axiosPrivate.put(`/admin/driver-video/update`, values);
  if (response.data.code !== 200) {
    throw new Error(response.data.message || "Request Failed.");
  }
  return response.data;
};

export const deleteDriverVideo = async (id) => {
  const response = await axiosPrivate.delete(
    `/admin/driver-video/delete/${id}`,
  );
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getBadges = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/badge${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleBadge = async (id) => {
  const response = await axiosPrivate.get(`/admin/badge/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addBadge = async (values) => {
  const response = await axiosPrivate.post(`/admin/badge`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateBadge = async (values) => {
  const response = await axiosPrivate.put(`/admin/badge/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getTiers = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/tier${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getSingleTier = async (id) => {
  const response = await axiosPrivate.get(`/admin/tier/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const addTier = async (values) => {
  const response = await axiosPrivate.post(`/admin/tier`, values);
  if (response.data.code !== 201)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const updateTier = async (values) => {
  const response = await axiosPrivate.put(`/admin/tier/update`, values);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getUserBadge = async (id) => {
  const response = await axiosPrivate.get(`/admin/user/badge/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getDriverBadge = async (id) => {
  const response = await axiosPrivate.get(`/admin/driver/badge/${id}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};

export const getTransactions = async (params = {}) => {
  const query = params?.params ? `${params.params}` : ""; // Check if params exist, otherwise default to an empty string
  const response = await axiosPrivate.get(`/admin/transaction${query}`);
  if (response.data.code !== 200)
    throw new Error(response.data ?? "Request Failed.");
  return response.data.results;
};
